import { scroll } from './index';

export default {
    // snippet received from Marketo
    // use it as is
    mixins: [ scroll ],
    methods: {
        marketo_form() {
            return $.getScript("//app-abb.marketo.com/js/forms2/js/forms2.min.js", (data, textStatus, jqxhr) => {
                if ( typeof MktoForms2 === 'object' ) {
                    MktoForms2.loadForm("//app-ab10.marketo.com", this.account, this.form);

                    MktoForms2.whenReady((form) => {

                        // remove inline styles on inital form load
                        this.remove_styles(form);

                        $("#marketingConsent").prop("checked", true);

                        $("#Country").change(function() {
                            $('input[name="marketingConsent"]').closest('.mktoFormRow').removeClass('input-has-value');
                            var id = $(this).find("option:selected").attr("value");

                            if (id == "Canada") {
                                $("#marketingConsent").prop("checked", false);
                            }
                            else {
                                $("#marketingConsent").prop("checked", true);
                            }
                        });

                        $('.mktoForm button').on('click', function (e) {
                            var isValid = true;
                            $('.mktoForm input').each(function() {
                                if ($.trim($(this).val()) == '') {
                                    isValid = false;
                                    $(this).removeClass('fl-active1');
                                    $(this).addClass('fl-active');
                                    $(this).prev().prev().addClass('fl-active');
                                }
                                else {
                                    $(this).addClass('fl-active');
                                }
                            });
                        });
                        let _self = this;
                        form.onSuccess(function(values, followUpUrl){
                            console.log(_self.$options.name)
                            _self.scroll({
                                to: `.${_self.$options.name}`,
                                duration: 1200,
                                callback: (() => { })
                            });
                            // quiz
                            // create localStorage obejct
                            if ( location.pathname.split('/').filter(a => a).slice(-1)[0] === 'free-online-sleep-assessment' ) {
                                localStorage.setItem('quizUser', JSON.stringify({
                                    FirstName: values.FirstName,
                                    LastName: values.LastName,
                                    Email: values.Email,
                                    Country: values.Country,
                                    MarketingConsent: values.marketingConsent === 'yes'
                                }));
                                window.location = `${location.href}/quiz`;

                                return false;
                            }

                            var divsToHide = document.getElementsByClassName("mktoFieldDescriptor");
                            for(var i = 0; i < divsToHide.length; i++){
                                divsToHide[i].style.display = "none";
                            }
                            var divsToHide = document.getElementsByClassName("mktoButton");
                            for(var i = 0; i < divsToHide.length; i++){
                                divsToHide[i].style.display = "none";
                            }
                            var fieldsetToShow = document.getElementsByTagName("fieldset");
                            for (var i = 0; i < fieldsetToShow.length; i++){
                                fieldsetToShow[i].style.display = "block";
                            }

                            //return false to prevent the submission handler from taking the lead to the follow up url.
                            return false;
                        });
                    });
                }
            });
        },
        get_marketo(){
          return $.getScript("//app-abb.marketo.com/js/forms2/js/forms2.min.js", (data, textStatus, jqxhr) => { })
        },
        munchkin() {
            return $.getScript("//munchkin.marketo.net/munchkin.js", (data, textStatus, jqxhr) => {
                Munchkin.init(this.account);
            });
        },
        remove_styles(form) {
            let formEl = form.getFormElem()[0];

            // remove element styles from root and children (may want to disable this while debugging)
            for (var elsWithStyles = document.querySelectorAll('#' + formEl.id + ', #' + formEl.id + ' [style]'), i = 0, imax = elsWithStyles.length; i < imax; i++) {
                elsWithStyles[i].removeAttribute('style');
            }

            // disable all marketo-sourced stylesheets
            for (var styleSheets = document.styleSheets, i = 0, imax = styleSheets.length; i < imax; i++) {
                var ssLoc = document.createElement('A');
                ssLoc.href = styleSheets[i].href;

                if ((ssLoc.hostname.search(/\.marketo\.com$/) !== -1) // external styles
                || ((styleSheets[i].ownerNode || styleSheets[i].owningElement).parentNode == formEl)) { // inline styles within form tag
                    styleSheets[i].disabled = true;
                }
            }
        }
    }
}
